import pluginOptionsSchema from './pluginOptionsSchema';

export default pluginOptionsSchema;
